var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.4,
    height: 11,
    viewBox: "0 0 9.4 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_upload",
    "data-name": "Icon upload",
    transform: "translate(10.3 10.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6238",
    "data-name": "Trazado 6238",
    d: "M7.4,18.9h8.4",
    transform: "translate(-6 -8.9)",
    fill: "none",
    stroke: "#3e3f42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6239",
    "data-name": "Trazado 6239",
    d: "M17.6,5.8,14.8,3,12,5.8",
    transform: "translate(20.4 12.1) rotate(180)",
    fill: "none",
    stroke: "#3e3f42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6240",
    "data-name": "Trazado 6240",
    d: "M18,3v9.1",
    transform: "translate(23.6 12.1) rotate(180)",
    fill: "none",
    stroke: "#3e3f42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadGallery);
export default __webpack_public_path__ + "static/media/icon-upload-gallery.5181738242758144e00ea0295ee3f542.svg";
export { ForwardRef as ReactComponent };